module.exports = __webpack_public_path__ + "static/img/advertisement1.e9534f3d.png";